<template>
   <div class="" id="block_color_picker">
      <info-box :title="'Block Color Picker'">
         <div class="color-row">
            <color-picker-square
               color="#647824"
               :currColor="currColor"
               @click.native="$emit('changeColor', '#647824')">
            </color-picker-square>

            <color-picker-square
               color="#73c4d3"
               :currColor="currColor"
               @click.native="$emit('changeColor', '#73c4d3')">
            </color-picker-square>

            <color-picker-square
               color="#f45918"
               :currColor="currColor"
               @click.native="$emit('changeColor', '#f45918')">
            </color-picker-square>

            <color-picker-square
               color="#f8c440"
               :currColor="currColor"
               @click.native="$emit('changeColor', '#f8c440')">
            </color-picker-square>

            <color-picker-square
               color="#de3b5a"
               :currColor="currColor"
               @click.native="$emit('changeColor', '#de3b5a')">
            </color-picker-square>
         </div>

         <div class="color-row">
            <color-picker-square
               color="#dd4afb"
               :currColor="currColor"
               @click.native="$emit('changeColor', '#dd4afb')">
            </color-picker-square>

            <color-picker-square
               color="#46acaa"
               :currColor="currColor"
               @click.native="$emit('changeColor', '#46acaa')">
            </color-picker-square>

            <color-picker-square
               color="#2697d8"
               :currColor="currColor"
               @click.native="$emit('changeColor', '#2697d8')">
            </color-picker-square>

            <color-picker-square
               color="#797979"
               :currColor="currColor"
               @click.native="$emit('changeColor', '#797979')">
            </color-picker-square>

            <color-picker-square
               color="#38da2a"
               :currColor="currColor"
               @click.native="$emit('changeColor', '#38da2a')">
            </color-picker-square>
         </div>
      </info-box>
   </div>
</template>

<script>
export default {
   props:{
      currColor : String
   }
}
</script>

<style lang="scss" scoped>
.color-row {
   display: flex;
   width: 200px;
   justify-content: space-between;
   margin-bottom: 2px;

   &:hover {
      cursor: pointer;
   }
}
</style>